import * as Yup from 'yup';
export const initialSiteInformationValues = {
    description: '',
    name: '',
};
export const siteInformationSchema = Yup.object().shape({
    name: Yup.string().required('Site Information Name is Required'),
});
//# sourceMappingURL=site-information.js.map